import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import * as routerHelpers from "../../router/RouterHelpers";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  ClearLegacyToken: "[ClearLegacyToken] Action",
  SetMfaEnabled: "[SetMfaEnabled] Action",
  UpdateFeatureFlags: "[Update Feature Flags] Action",
};

const initialAuthState = {
  me: undefined,
  authToken: undefined,
  autorizado_migrar: undefined,
  feature_flags: undefined,
};

export const reducer = persistReducer(
  {
    storage,
    key: "app-auth",
    whitelist: [
      "me",
      "user",
      "authToken",
      "autorizado_migrar",
      "feature_flags",
    ],
  },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        return {
          authToken: action.payload.authToken,
          me: action.payload.user,
          autorizado_migrar: action.payload.autorizado_migrar,
          feature_flags: action.payload.feature_flags,
        };
      }

      case actionTypes.Logout: {
        routerHelpers.forgotLastLocation();
        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
        return {
          ...state,
          me: action.payload,
        };
      }

      case actionTypes.ClearLegacyToken: {
        return {
          ...state,
          authToken: undefined,
        };
      }

      case actionTypes.UpdateFeatureFlags: {
        return {
          ...state,
          feature_flags: action.payload,
        };
      }

      case actionTypes.SetMfaEnabled: {
        if (!state.me?.user) return state;
        return {
          ...state,
          me: {
            ...state.me,
            user: {
              ...state.me.user,
              mfaEnabled: action.payload,
            },
          },
        };
      }

      default:
        return state;
    }
  },
);

export const actions = {
  login: (payload) => ({ type: actionTypes.Login, payload }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: (payload) => ({ type: actionTypes.UserRequested, payload }),
  fulfillUser: (payload) => ({ type: actionTypes.UserLoaded, payload }),
  clearLegacyToken: () => ({ type: actionTypes.ClearLegacyToken }),
  setMfaEnabled: (payload) => ({ type: actionTypes.SetMfaEnabled, payload }),
};

export function* saga() {}
